{
  "leads.assign.shared": "One person takes them all; several people share them evenly. Each lead keeps its history, and its timer starts again for the new owner.",
  "leads.assign.stage": "Stage after handing over",
  "leads.filter.timer": "Timer",
  "leads.filter.timer.overdue": "Time's up",
  "leads.filter.timer.soon": "Under 2 working hours left",
  "leads.filter.timer.withLeader": "Waiting with the leader",
  "leads.import.title": "Import leads",
  "leads.import.body": "Any sheet works: pick where the leads go, then tell us which column is the name and which is the phone.",
  "leads.import.source": "Source",
  "leads.import.project": "Project",
  "leads.import.pickProject": "Pick a project",
  "leads.import.stage": "Stage",
  "leads.import.coldHint": "They wait in the Cold calls pool of the owners' team, for a team leader to pull.",
  "leads.import.owners": "Who takes them",
  "leads.import.single": "Single",
  "leads.import.multi": "Multi",
  "leads.import.singleHint": "One person takes every lead in the sheet. Nobody picked: they're yours.",
  "leads.import.multiHint": "The people you pick share the leads evenly, one after another.",
  "leads.import.mappingTitle": "Columns in your sheet",
  "leads.import.mappingCaption": "{rows} rows found. Match each column to a lead field; the phone is required.",
  "leads.import.col.file": "Column in your sheet",
  "leads.import.col.sample": "Sample",
  "leads.import.col.field": "Goes to",
  "leads.import.col.fieldFor": "Lead field for {column}",
  "leads.import.noHeading": "(no heading)",
  "leads.import.skip": "Don't import",
  "leads.import.field.name": "Name",
  "leads.import.field.phone": "Phone",
  "leads.import.field.second_phone": "Second phone",
  "leads.import.field.email": "Email",
  "leads.import.field.notes": "Notes",
  "leads.import.needs": "Pick a source and the phone column.",
  "leads.import.done": "{imported, plural, one {# lead imported} other {# leads imported}}{skipped, plural, =0 {.} one {, # skipped (already a lead or no phone).} other {, # skipped (already leads or no phone).}}",
  "leads.assign.keepStage": "Keep each lead's current stage",
  "leads.col.timeLeft": "Time left",
  "leads.limit.hours": "{count, plural, one {# working hour} other {# working hours}}",
  "leads.limit.days": "{count, plural, one {# working day} other {# working days}}",
  "leads.limit.none": "No time limit",
  "leads.stats.reserved": "Reservations",
  "leads.stats.closed": "Closed deals",

  "leads.countdown.left": "{left} left",
  "leads.countdown.pausedHint": "Paused outside working hours. Resumes {time}.",
  "leads.countdown.pausedLine": "{left} left · paused until {time}",
  "leads.countdown.withLeader": "With team leader",
  "leads.countdown.withLeaderHint": "The whole team had this lead in the last 24 hours, so it waits with the team leader in Cold calls. It moves again when its status changes or it is pulled.",

  "leads.reservation.title": "Reservation",
  "leads.reservation.description": "What did {name} reserve? The developer is required; the rest can be added later.",
  "leads.reservation.pickDeveloper": "Choose the developer",
  "leads.reservation.pickProject": "Choose the project",
  "leads.reservation.developerRequired": "Choose the developer of the reserved unit.",
  "leads.reservation.unit": "Unit number",
  "leads.reservation.confirm": "Save reservation",
  "leads.reservation.saved": "{name} moved to Reservation.",

  "leads.closed.title": "Closed deal",
  "leads.closed.description": "What was the deal with {name} worth, and when did they sign?",
  "leads.closed.date": "Closing date",
  "leads.closed.value": "Deal value",
  "leads.closed.valueHint": "Counts toward the sales target.",
  "leads.closed.confirm": "Close the deal",
  "leads.closed.saved": "Deal with {name} closed.",

  "leads.files.title": "Files",
  "leads.files.drop": "Drop the reservation form, receipt or photos",
  "leads.files.types": "PDF, JPG, PNG or WebP · up to 10 MB each",
  "leads.files.rejected": "{count, plural, one {1 file was skipped: only PDF or photos up to 10 MB.} other {# files were skipped: only PDF or photos up to 10 MB.}}",
  "leads.files.none": "No files yet.",
  "leads.files.uploaded": "Files added.",
  "leads.files.uploading": "Uploading…",

  "leads.form.developer": "Developer of interest",
  "leads.form.firstComment": "First comment",

  "leads.comments.title": "Comments",
  "leads.comments.add": "Post comment",
  "leads.comments.posting": "Posting…",
  "leads.comments.placeholder": "What happened? A call, a visit, what the client said…",
  "leads.comments.final": "Comments can't be edited or deleted once posted.",
  "leads.comments.while": "while {status}",
  "leads.comments.kind": "What this comment records",
  "leads.comments.kind.note": "Note",
  "leads.comments.kind.call": "Call",
  "leads.comments.kind.whatsapp": "WhatsApp",
  "leads.comments.emptyTitle": "No comments yet",
  "leads.comments.emptyBody": "Write down each call and visit, so whoever has this lead next knows the story.",

  "leads.journey.title": "Journey",
  "leads.journey.timeLeft": "Time on this status",
  "leads.journey.since": "On this status since",
  "leads.journey.moves": "Moves",
  "leads.journey.movesValue": "{rotations, plural, one {# rotation} other {# rotations}} · {pulls, plural, one {# pull} other {# pulls}}",
  "leads.journey.interest": "Interested in",
  "leads.journey.reserved": "Reserved",
  "leads.journey.reservedAt": "Reserved on",
  "leads.journey.closedAt": "Closed on",
  "leads.journey.dealValue": "Deal value",

  "pool.description": "Leads that didn't work out: canceled, or passed round the whole team. Pull a number of them back to agents; each starts again at Fresh.",
  "pool.loadFailed": "Couldn't load the pool. Try again.",
  "pool.stats.total": "In the pool",
  "pool.stats.canceledHint": "Clients who dropped out",
  "pool.stats.rotationHint": "Went round the whole team",
  "pool.source.both": "Both",
  "pool.source.canceled": "Canceled",
  "pool.source.rotation": "Rotation",
  "pool.col.lead": "Lead",
  "pool.col.from": "From",
  "pool.col.lastOwner": "Last owner",
  "pool.col.rotations": "Rotations",
  "pool.col.pulls": "Pulled before",
  "pool.col.since": "In pool since",
  "pool.empty.title": "The pool is empty",
  "pool.empty.body": "Canceled leads, and leads the whole team had, show up here.",
  "pool.recent.title": "Recent pulls",
  "pool.recent.line": "{name} pulled {count, plural, one {1 lead} other {# leads}} from {source}",
  "pool.pulled": "{count, plural, one {1 lead} other {# leads}} dealt to {agents, plural, one {1 agent} other {# agents}}. They're Fresh on the Leads board.",
  "pool.openLeads": "Open Leads",

  "pool.pull.action": "Pull numbers",
  "pool.pull.title": "Pull numbers",
  "pool.pull.description": "The oldest in the pool go first. They are dealt evenly, skipping anyone who had a lead in the last 24 hours where possible.",
  "pool.pull.from": "From",
  "pool.pull.count": "How many",
  "pool.pull.less": "Fewer",
  "pool.pull.more": "More",
  "pool.pull.onlyAvailable": "Only {count} available",
  "pool.pull.agents": "To these agents",
  "pool.pull.all": "Select all",
  "pool.pull.none": "Clear",
  "pool.pull.pickAgents": "Pick at least one agent.",
  "pool.pull.preview": "{count} leads → {agents, plural, one {1 agent} other {# agents}}, {each} each",
  "pool.pull.previewUneven": "{count} leads → {agents, plural, one {1 agent} other {# agents}}, {each} or {each}+1 each",
  "pool.pull.confirm": "{count, plural, one {Pull 1 lead} other {Pull # leads}}",
  "pool.pull.pulling": "Pulling…",

  "hours.description": "When status timers run. Outside these hours every countdown pauses and no lead rotates.",
  "hours.start": "Opens at",
  "hours.end": "Closes at",
  "hours.endAfterStart": "Closing time must be after opening time.",
  "hours.days": "Working days",
  "hours.noDays": "With no working days, timers never pause.",
  "hours.explain": "Times are {timezone} time. A lead that enters Fresh (2 hours) half an hour before closing has 1½ hours left when you open the next working day.",
  "hours.saved": "Working hours saved. Every timer follows them now.",

  "common.remove": "Remove"
}
